// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-datatable {
  background-color: #1b282f;
  color: white;
}

.p-datatable-table {
  padding: 2px;
  margin-top: 4px;
}

.p-datatable .p-datatable-header {
  background-color: #1b282f;
  border: none;
  font-family: "URW DIN Cond";
}

.table-header {
  background-color: #1b282f;
  color: white;
  border-color: rgb(76, 76, 77);
  font-weight: 600;
  font-family: "URW DIN Cond";
}

.p-datatable th {
  background-color: #1b282f;
  color: #cad4d9;
  padding: 18px 0px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  font-family: "URW DIN Cond";
}

.p-datatable-tbody > tr:nth-child(odd) {
  background-color: #2c3d45;
  color: white;
}

.p-datatable td {
  border-bottom: 1px solid #3a4c55;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  padding: 0px 0px;
  vertical-align: middle;
  font-family: "URW DIN Cond", sans-serif;
}

.p-datatable-tbody > tr:nth-child(even) {
  background-color: #1b282f;
  color: white;
}

.pagination-container button {
  color: rgb(253, 253, 253);
  border: none;
  padding: 5px 10px;
  transition: background-color 0.3s, color 0.3s;
  font-family: "URW DIN Cond", sans-serif;
}

.pagination-container button:disabled {
  color: grey;
}

/* Hover effect for pagination buttons */
.pagination-container button:hover {
  background-color: #1b282f;
  color: white;
  cursor: pointer;
}

.table-header {
  background-color: #1b282f;
  border-bottom: 1px solid rgb(76, 76, 77);
}

.p-datatable .p-datatable-tbody > tr:hover {
  background-color: rgba(156, 156, 156, 0.473);
  cursor: pointer;
}

.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {
  color: #ffffff;
}

.pagination-container {
  border: 1px solid #1b282f;
  font-family: "URW DIN Cond";
  font-size: 16px;
}

.total-row {
  border-bottom: 1px solid #3a4c55;
  font-family: "URW DIN Cond";
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/customStyles.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;AACjB","sourcesContent":[".p-datatable {\r\n  background-color: #1b282f;\r\n  color: white;\r\n}\r\n\r\n.p-datatable-table {\r\n  padding: 2px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.p-datatable .p-datatable-header {\r\n  background-color: #1b282f;\r\n  border: none;\r\n  font-family: \"URW DIN Cond\";\r\n}\r\n\r\n.table-header {\r\n  background-color: #1b282f;\r\n  color: white;\r\n  border-color: rgb(76, 76, 77);\r\n  font-weight: 600;\r\n  font-family: \"URW DIN Cond\";\r\n}\r\n\r\n.p-datatable th {\r\n  background-color: #1b282f;\r\n  color: #cad4d9;\r\n  padding: 18px 0px;\r\n  border: none;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  font-family: \"URW DIN Cond\";\r\n}\r\n\r\n.p-datatable-tbody > tr:nth-child(odd) {\r\n  background-color: #2c3d45;\r\n  color: white;\r\n}\r\n\r\n.p-datatable td {\r\n  border-bottom: 1px solid #3a4c55;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  color: #ffffff;\r\n  padding: 0px 0px;\r\n  vertical-align: middle;\r\n  font-family: \"URW DIN Cond\", sans-serif;\r\n}\r\n\r\n.p-datatable-tbody > tr:nth-child(even) {\r\n  background-color: #1b282f;\r\n  color: white;\r\n}\r\n\r\n.pagination-container button {\r\n  color: rgb(253, 253, 253);\r\n  border: none;\r\n  padding: 5px 10px;\r\n  transition: background-color 0.3s, color 0.3s;\r\n  font-family: \"URW DIN Cond\", sans-serif;\r\n}\r\n\r\n.pagination-container button:disabled {\r\n  color: grey;\r\n}\r\n\r\n/* Hover effect for pagination buttons */\r\n.pagination-container button:hover {\r\n  background-color: #1b282f;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.table-header {\r\n  background-color: #1b282f;\r\n  border-bottom: 1px solid rgb(76, 76, 77);\r\n}\r\n\r\n.p-datatable .p-datatable-tbody > tr:hover {\r\n  background-color: rgba(156, 156, 156, 0.473);\r\n  cursor: pointer;\r\n}\r\n\r\n.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {\r\n  color: #ffffff;\r\n}\r\n\r\n.pagination-container {\r\n  border: 1px solid #1b282f;\r\n  font-family: \"URW DIN Cond\";\r\n  font-size: 16px;\r\n}\r\n\r\n.total-row {\r\n  border-bottom: 1px solid #3a4c55;\r\n  font-family: \"URW DIN Cond\";\r\n  font-size: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
